// Request<T> - Matches C# Earlymed.Domains.Request<T>
export interface Request<T> {
  data: T | null;
  validationErrors?: Record<string, string>;
  isValid: boolean; // Computed: validationErrors == null || Object.keys(validationErrors).length === 0
}

// Helper to create a valid request
export function createRequest<T>(data: T): Request<T> {
  return {
    data,
    isValid: true,
  };
}

// Helper to create a request with validation errors
export function createRequestWithErrors<T>(errors: Record<string, string>): Request<T> {
  return {
    data: null,
    validationErrors: errors,
    isValid: false,
  };
}
